<div
  class="nav-item"
  [ngClass]="{ active: isActiveMenuItem() }"
  (mouseenter)="mouseEnter($event)"
  (mouseleave)="mouseLeave($event)"
  (click)="reRouteToOutlet($event)"
  title="{{ title }}"
>
  @if (showIcon()) {
    <mat-icon class="material-symbols-outlined nav-item__icon" [matBadge]="badgeText" matBadgeSize="small" (aria-hidden)="(!hasBadge)">{{
      icon
    }}</mat-icon>
  }
  @if (showText()) {
    <span class="nav-item__text">{{ title }}</span>
  }
</div>
